import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=17b9a49d&"
import script from "./colorPicker.ts?vue&type=script&lang=js&"
export * from "./colorPicker.ts?vue&type=script&lang=js&"
import style0 from "./colorPicker.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports